export const windowSize = (type: 'width' | 'height') => {
    if (type === 'width') {
        return window.outerWidth;
    } else {
        return window.outerHeight;
    }
};
